import { Injectable } from '@angular/core';
import { ResourceManager, ResourceManagerService } from '@barthauer/abc/core/resources';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class LanguageService {
  languageParam = sessionStorage.getItem('fixedCulture') ?? document.documentElement.lang;

  private localStorageSubject = new BehaviorSubject<string>(this.languageParam);
  localStorageChanges$ = this.localStorageSubject.asObservable();

  setValue(key: string, value: string): void {
    ResourceManagerService.setFixedCulture(value);
    ResourceManager.changeLanguage(value);

    this.localStorageSubject.next(value);
  }

  changeLanguage(language: string) {
    this.localStorageSubject.next(language);
  }

  getValue(key: string): string | null {
    return sessionStorage.getItem(key);
  }
}
